import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IAssociationsPayload, IInitialStateAssociations} from "../types";
import {GetAssociations} from "./thunks";



const initialState: IInitialStateAssociations = {
    associationsData:[],
    associationRestoreData:[],
    isViewAssociations: false,
    isLoadingAssociations:false,
    associationsSelectedIDs:[],
}

const associationsSlice = createSlice({
    name: "associations",
    initialState,
    reducers: {
        setAssociations: (state, action:PayloadAction<IAssociationsPayload[]> ) => {
            state.associationsData=action.payload;


        },

        deletedAssociations: (state, action: PayloadAction<number>) => {
            state.associationsData = state.associationsData.filter(
                (elem) => elem.id !== action.payload
            );
        },
        updateAssociations: (state, action) => {
            const updateData = action.payload;

            state.associationsData = state.associationsData.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        deletedRestoreAssociations:(state,action)=>{
            state.associationRestoreData = state.associationRestoreData.filter(
                (elem) => elem.id !== action.payload
            );
        },
        setAssociationsRestoreData:(state,action)=>{
            state.associationRestoreData = action.payload;
        },
        setIsViewAssociations:(state)=>{

            state.isViewAssociations =!state.isViewAssociations;
        },
        setSelectedAssociationsIDs: (state, action) => {
            state.associationsSelectedIDs=action.payload
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAssociations.pending, (state) => {
                state.isLoadingAssociations = true;
            })
            .addCase(GetAssociations.fulfilled, (state) => {
                state.isLoadingAssociations = false;
            })
            .addCase(GetAssociations.rejected, (state) => {
                state.isLoadingAssociations = false;
            })
    }
})
export const {
    setIsViewAssociations,
    setAssociations,
    deletedAssociations,
    updateAssociations,
    setSelectedAssociationsIDs,
    setAssociationsRestoreData,
    deletedRestoreAssociations,


} = associationsSlice.actions;

export default associationsSlice